module.exports = __webpack_public_path__ + "img/product3.17b8d773.jpg";